import React, { useState } from "react";
import {
  Edit,
  SimpleForm,
  TextInput,
  BooleanInput,
  SelectInput,
  FormDataConsumer,
  ArrayInput,
  SimpleFormIterator,
  FileInput,
  FileField,
} from "react-admin";
import { RichTextInput } from "ra-input-rich-text";
import { languageChoices } from "../../../utils/options";
import { Typography } from "@mui/material";
import { ActiveEditToolbar } from "../Partials/CustomComponents/ActiveSaveToolbar";
import { arrayLabel, editTitle } from "../../../customStyles/ra-custom-styles";
import { CustomFile, EmptyFiles } from "components/features/Partials/CustomComponents/CustomFile";
import CustomDateInput from "common/components/Fields/CustomDateInput";

const CompetitionEdit = () => {
  const [filesToDelete, setFilesToDelete] = useState([]);
  const handleChange = id => {
    if (filesToDelete.includes(id)) {
      setFilesToDelete([...filesToDelete.filter(item => item !== id)]);
    } else {
      setFilesToDelete([...filesToDelete, id]);
    }
  };
  const transform = data => ({
    ...data,
    delete_files_ids: [...filesToDelete],
    files: data.files
      ? data.files.map(fileItem => ({
          name: fileItem.name, // Keep the name as it is
          file: fileItem.file.rawFile, // Directly use the binary file data (rawFile)
        }))
      : null,
  });

  return (
    <Edit
      title="Конкурс"
      mutationMode="pessimistic"
      sx={editTitle}
      transform={transform}
    >
      <Typography sx={editTitle}>Редакция на конкурс </Typography>
      <SimpleForm toolbar={<ActiveEditToolbar />}>
        <TextInput
          label="ID"
          source="id"
          disabled
        />
        <SelectInput
          label="Език"
          source="language"
          choices={languageChoices}
        />
        <TextInput
          label="Име"
          source="title"
          fullWidth
        />{" "}
        <RichTextInput
          label="Съдържание"
          source="content"
        />{" "}
        <FormDataConsumer>
          {({ formData, ...rest }) => {
            if (formData.competition_files?.length === 0) {
              return <EmptyFiles />;
            } else {
              return (
                <CustomFile
                  data={formData.competition_files}
                  handleChange={handleChange}
                  filesToDelete={filesToDelete}
                />
              );
            }
          }}
        </FormDataConsumer>
        <ArrayInput
          source="files"
          label="Качете файл"
          sx={arrayLabel}
        >
          <SimpleFormIterator disableReordering>
            <FileInput
              placeholder="Качете файл"
              label="Файл"
              source="file"
              maxSize={54525952}
            >
              <FileField
                source="src"
                title="title"
              />
            </FileInput>
            <TextInput
              label="Име на файла"
              source="name"
              fullWidth
            />
          </SimpleFormIterator>
        </ArrayInput>
        <CustomDateInput
          label="Дата на публикуване"
          source="started_on"
        />
        <BooleanInput
          label="Скрита"
          source="is_hidden"
        />
      </SimpleForm>
    </Edit>
  );
};

export default CompetitionEdit;
